var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body has-padding-100"},[_c('no-results',{attrs:{"title":`Error ${_vm.error}`,"message":_vm.messages[_vm.error],"cta":{ label: 'Go back' },"icon":"exclamation-circle"},on:{"click":function($event){return _vm.$router.go(-1)}}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }